import { CreateNonCashBenefitUsageDTONonCashBenefitEnum } from 'probonio-shared-ui/api';

export type NonCashBenefit = CreateNonCashBenefitUsageDTONonCashBenefitEnum;
export const NonCashBenefit = CreateNonCashBenefitUsageDTONonCashBenefitEnum;
